import regeneratorRuntime from "/app/node_modules/.pnpm/next@12.1.0_494256c3f529d480d29e5d557f8f50cf/node_modules/next/dist/compiled/regenerator-runtime/runtime.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable max-len */ // import '@tencent/particle-ui/dist/pui.css';
// import '@tencent/cms-design-component/lib/dist/style/main.css';
import logger from 'common/utils/udp-logger';
import Head from 'next/head';
import { getTips } from 'portal-common/components/LanguagNone/resource/trans-tip';
import React from 'react';
import { getPriceTabData, getTceTableData } from '../apis/buyApi';
import { getPageDetail } from '../apis/cmsApi';
// import { queryFormInfo } from '../apis/formApi';
import GemsRender from '../components/GemsRender';
import OldRender from '../components/OldRender';
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
export var getData = function() {
    var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(param) {
        var locale, defaultLocale, eid, isPreview, domains, lg, ref, data, msg, code, isNewEditorData, components, ref1, ref2, ref3, ref4, ref5, ref6, langTip, noticeCom, tceTableItem, ref7, code1, pData, item1, ref8, code2, pData1;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    locale = param.locale, defaultLocale = param.defaultLocale, eid = param.eid, isPreview = param.isPreview, domains = param.domains;
                    lg = locale || defaultLocale;
                    _ctx.prev = 2;
                    if (!(eid === 'undefined')) {
                        _ctx.next = 5;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        notFound: true
                    });
                case 5:
                    _ctx.next = 7;
                    return getPageDetail(eid, isPreview);
                case 7:
                    ref = _ctx.sent;
                    data = ref.data;
                    msg = ref.msg;
                    code = ref.code;
                    if (!(!code && data && typeof data === 'object')) {
                        _ctx.next = 36;
                        break;
                    }
                    isNewEditorData = !!data.langPage;
                    components = [];
                    if (isNewEditorData) {
                        ;
                        components = ((ref1 = data.langPage) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[lg]) === null || ref2 === void 0 ? void 0 : ref2.components) || [];
                    } else {
                        ;
                        components = ((ref3 = data.components) === null || ref3 === void 0 ? void 0 : ref3.filter(function(item) {
                            return item.lang === lg;
                        })) || [];
                    }
                    if (components.length === 0) {
                        ;
                        langTip = getTips('express', lg);
                        lg = 'en';
                        components = ((ref4 = data.langPage) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.en) === null || ref5 === void 0 ? void 0 : ref5.components) || ((ref6 = data.components) === null || ref6 === void 0 ? void 0 : ref6.filter(function(item) {
                            return item.lang === lg;
                        })) || [];
                        noticeCom = {
                            id: 'component/Notice',
                            name: 'Notice',
                            key: 999,
                            style: {},
                            commonStyle: {},
                            wrapperStyle: {},
                            data: {
                                noFix: true,
                                longTimeMode: true,
                                noticeDesc: langTip,
                                noticeType: 'notice'
                            }
                        };
                        components.unshift(noticeCom);
                    }
                    if (!(components.length === 0)) {
                        _ctx.next = 19;
                        break;
                    }
                    logger.error('notFound', {
                        desc: 'components length == 0',
                        locale: locale,
                        defaultLocale: defaultLocale,
                        eid: eid,
                        isPreview: isPreview
                    });
                    return _ctx.abrupt("return", {
                        notFound: true
                    });
                case 19:
                    tceTableItem = components.find(function(item) {
                        return item.component_id === 'TceTable' && item.lang === lg || item.name === 'TceTable';
                    });
                    if (!tceTableItem) {
                        _ctx.next = 27;
                        break;
                    }
                    _ctx.next = 23;
                    return getTceTableData();
                case 23:
                    ref7 = _ctx.sent;
                    code1 = ref7.code;
                    pData = ref7.data;
                    if (!code1) {
                        tceTableItem.data.tceTableData = pData;
                    } else {
                        logger.error('getTceTableData', {
                            lg: lg,
                            pData: pData,
                            code: code1
                        });
                        // 如果请求异常就删除该组件的显示
                        components.splice(components.indexOf(item1), 1);
                    }
                case 27:
                    item1 = components.find(function(item) {
                        return item.component_id === 'ProductsService' && item.lang === lg || item.name === 'ProductsService';
                    });
                    if (!item1) {
                        _ctx.next = 35;
                        break;
                    }
                    _ctx.next = 31;
                    return getPriceTabData(lg, domains);
                case 31:
                    ref8 = _ctx.sent;
                    code2 = ref8.code;
                    pData1 = ref8.data;
                    if (!code2) {
                        if (isNewEditorData) {
                            item1.data.productsServiceData = pData1;
                        } else {
                            item1.productsServiceData = pData1;
                        }
                    } else {
                        logger.error('getPriceTabData', {
                            lg: lg,
                            pData: pData1,
                            code: code2
                        });
                        // 如果请求异常就删除该组件的显示
                        components.splice(components.indexOf(item1), 1);
                    }
                case 35:
                    return _ctx.abrupt("return", {
                        props: {
                            code: code,
                            msg: msg,
                            lang: lg,
                            isPreview: isPreview,
                            configData: data,
                            domains: domains
                        }
                    });
                case 36:
                    logger.error('notFound', {
                        locale: locale,
                        defaultLocale: defaultLocale,
                        eid: eid,
                        isPreview: isPreview
                    });
                    return _ctx.abrupt("return", {
                        notFound: true
                    });
                case 40:
                    _ctx.prev = 40;
                    _ctx.t0 = _ctx["catch"](2);
                    logger.error('getData', {
                        desc: 'no data',
                        locale: locale,
                        defaultLocale: defaultLocale,
                        eid: eid,
                        isPreview: isPreview,
                        error: _ctx.t0
                    });
                    throw _ctx.t0;
                case 44:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                2,
                40
            ]
        ]);
    }));
    return function getData(_) {
        return _ref.apply(this, arguments);
    };
}();
var pageRenderer = function(props) {
    var code = props.code, configData = props.configData, location = props.location, lang = props.lang, isPreview = props.isPreview, domains = props.domains, other = _objectWithoutProperties(props, [
        "code",
        "configData",
        "location",
        "lang",
        "isPreview",
        "domains"
    ]);
    if (code) {
        return(/*#__PURE__*/ _jsx("div", {}));
    }
    try {
        // ✅ 防御性检查：确保 configData 存在且是对象
        if (!configData || typeof configData !== 'object') {
            logger.error('pageRenderer', {
                code: code,
                configData: configData,
                location: location,
                lang: lang,
                isPreview: isPreview,
                error: 'Invalid configData'
            });
            return(/*#__PURE__*/ _jsx("div", {}));
        }
        var isNewData = !!configData.langPage;
        var pageObject = configData.pageObject;
        // ✅ 防御性检查：确保 pageObject 存在
        if (!pageObject) {
            logger.error('pageRenderer', {
                code: code,
                configData: configData,
                location: location,
                lang: lang,
                isPreview: isPreview,
                error: 'Missing pageObject'
            });
            return(/*#__PURE__*/ _jsx("div", {}));
        }
        if (typeof pageObject === 'string') {
            try {
                pageObject = JSON.parse(pageObject);
            } catch (parseError) {
                logger.error('pageRenderer', {
                    code: code,
                    configData: configData,
                    location: location,
                    lang: lang,
                    isPreview: isPreview,
                    error: "Failed to parse pageObject: ".concat(parseError.message)
                });
                return(/*#__PURE__*/ _jsx("div", {}));
            }
        }
        // ✅ 防御性检查：确保 pageObject.langs 存在
        if (!pageObject.langs || typeof pageObject.langs !== 'object') {
            logger.error('pageRenderer', {
                code: code,
                configData: configData,
                location: location,
                lang: lang,
                isPreview: isPreview,
                error: 'Missing or invalid pageObject.langs'
            });
            return(/*#__PURE__*/ _jsx("div", {}));
        }
        var langInfo = pageObject.langs[lang] || {};
        if (Object.keys(langInfo).length === 0 && pageObject.langs.en) {
            langInfo = pageObject.langs.en;
        }
        return(/*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsxs(Head, {
                    children: [
                        /*#__PURE__*/ _jsx("title", {
                            children: langInfo.title || ''
                        }),
                        /*#__PURE__*/ _jsx("meta", {
                            name: "description",
                            content: langInfo.description || ''
                        }),
                        /*#__PURE__*/ _jsx("meta", {
                            name: "keywords",
                            content: langInfo.keyword || ''
                        })
                    ]
                }),
                isNewData ? /*#__PURE__*/ _jsx(GemsRender, _objectSpread({
                    lang: lang,
                    configData: configData,
                    isPreview: isPreview,
                    domains: domains
                }, other)) : /*#__PURE__*/ _jsx(OldRender, {
                    lang: lang,
                    configData: configData,
                    location: location,
                    isPreview: isPreview
                })
            ]
        }));
    } catch (error) {
        logger.error('pageRenderer', {
            code: code,
            configData: configData,
            location: location,
            lang: lang,
            isPreview: isPreview,
            error: error
        });
        throw error;
    }
};
// export const getRenderData = async ({ locale, defaultLocale, eid, isPreview, domains }) => {
//   const HomeAjax = require('portal-common/server/routes/render/ajax/index');
//   let lg = locale || defaultLocale;
//   try {
//     if (eid === 'undefined') {
//       return {
//         notFound: true,
//       };
//     }
//     const { data } = await HomeAjax.getPageInfo(eid, isPreview);
//     console.log('getRenderData--getPageInfo-', data);
//     // if (!code && data) {
//     //   const isNewEditorData = !!data.langPage;
//     //   let components = [];
//     //   if (isNewEditorData) {
//     //     components = data.langPage[lg]?.components || [];
//     //   } else {
//     //     components = data.components?.filter((item) => item.lang === lg);
//     //   }
//     //   if (components.length === 0) {
//     //     const langTip = getTips('express', lg);
//     //     lg = 'en';
//     //     components = data.langPage?.en?.components || data.components?.filter((item) => item.lang === lg) || [];
//     //     const noticeCom = {
//     //       id: 'component/Notice',
//     //       name: 'Notice',
//     //       key: 999,
//     //       style: {},
//     //       commonStyle: {},
//     //       wrapperStyle: {},
//     //       data: {
//     //         noFix: true,
//     //         longTimeMode: true,
//     //         noticeDesc: langTip,
//     //         noticeType: 'notice',
//     //       },
//     //     };
//     //     components.unshift(noticeCom);
//     //   }
//     //   if (components.length === 0) {
//     //     logger.error('notFound', { desc: 'components length == 0', locale, defaultLocale, eid, isPreview });
//     //     return {
//     //       notFound: true,
//     //     };
//     //   }
//     //   // const item = components.find((item) => (item.component_id === 'ProductsService' && item.lang === lg) || item.name === 'ProductsService');
//     //   // if (item) {
//     //   //   const { code, data: pData } = await getPriceTabData(lg, domains);
//     //   //   if (!code) {
//     //   //     if (isNewEditorData) {
//     //   //       item.data.productsServiceData = pData;
//     //   //     } else {
//     //   //       item.productsServiceData = pData;
//     //   //     }
//     //   //   } else {
//     //   //     logger.error('getPriceTabData', { lg, pData, code });
//     //   //     // 如果请求异常就删除该组件的显示
//     //   //     components.splice(components.indexOf(item), 1);
//     //   //   }
//     //   // }
//     //   // const table = components.find((item) => (item.component_id === 'FormTable' && item.lang === lg) || item.name === 'FormTable');
//     //   // if (table) {
//     //   //   const commodityObject = table.data.commodityObject || '{}';
//     //   //   if (commodityObject) {
//     //   //     const obj = JSON.parse(commodityObject);
//     //   //     const commodity = obj.commodity || '';
//     //   //     const { code, data: tData } = await HomeAjax.queryFormInfo({ ecId: commodity });
//     //   //     if (!code) {
//     //   //       table.data.tableData = JSON.parse(tData.customizeQust || '[]') || [];
//     //   //     } else {
//     //   //       logger.error('queryFormInfo', { lg, tData, code });
//     //   //       // 如果请求异常就删除该组件的显示
//     //   //       // components.splice(components.indexOf(table), 1);
//     //   //     }
//     //   //   }
//     //   // }
//     //   console.log('getRenderData---', data);
//     //   return {
//     //     props: {
//     //       code,
//     //       msg,
//     //       lang: lg,
//     //       isPreview,
//     //       configData: data,
//     //       domains,
//     //     },
//     //   };
//     // }
//     logger.error('notFound', { locale, defaultLocale, eid, isPreview });
//     return {
//       notFound: true,
//     };
//   } catch (error) {
//     logger.error('getData', {
//       desc: 'no data',
//       locale,
//       defaultLocale,
//       eid,
//       isPreview,
//       error,
//     });
//     throw error;
//   }
// };
export { pageRenderer };
